window.ResizeObserver ??= require('@juggle/resize-observer').ResizeObserver;

require('pinch-zoom-element-js');

const $             = require('jquery');
const _             = require('underscore');
const evtout        = require('../evtout');
const sidepanel     = require('../ctrl/sidepanel');
const Pagination    = require('../ctrl/pagination');
const Slider        = require('../ctrl/slider');

const fa = {
  fileDownload: require('@fortawesome/pro-light-svg-icons/faFileDownload').definition
};

const api = {};
const MIN_SCALE = 1;
const MAX_SCALE = 5;

let img = null;
let elem = null;
let slider = null;
let figure = null;
let pagination = null;
let transformable = null;
let resizeObserver = null;

function createElem(src) {
  return $(`
    <div class="figure-overlay busy">
      <div class="backdrop"></div>
      <pinch-zoom min-scale="${MIN_SCALE}" max-scale="${MAX_SCALE}">
        <img class="grabbable" src="${src}"/>
      </pinch-zoom>
      <spinner></spinner>
      <div class="figure-toolbar"></div>
    </div>
  `);
}

function figureDescription(description) {
  let idx = description.indexOf(':');
  if (idx == -1) return description;
  return description.substr(idx + 1);
}

function figureDetails(figure) {
  return $(`
    <div class="figure-details">
      <h2>Detailed Information</h2>
      <div>${figureDescription(figure.caption)}</div>
    </div>
  `);
}

function resetTransform() {
  if (!transformable) return;
  transformable.setTransform({
    allowChangeEvent: true,
    scale: MIN_SCALE,
    x: 0, y: 0
  });
}

function resizeImgToFit() {
  if (!img  || !img.length) return;
  if (!elem || !elem.length) return;

  const maxWidth  = elem.width() - 40;
  const maxHeight = elem.height() - 80;

  if (img[0].naturalHeight > maxHeight) {
    img.css('max-height', maxHeight);
  }
  if (img[0].naturalWidth > maxWidth) {
    img.css('max-width', maxWidth);
  }
}

function open(index, figures, parent) {
  if (!figures[index]) return;

  figure = Object.assign({ index }, figures[index]);
  elem = createElem(figure.url).appendTo(parent);

  resizeObserver = new ResizeObserver(resizeImgToFit);
  resizeObserver.observe(elem[0]);

  img = elem.find('img');
  img.one('error', close);
  img.one('load', () => {
    resizeImgToFit();
    setBusy(false);
  });

  slider = Slider({
    label: 'Zoom',
    container: elem.find('.figure-toolbar'),
    min: MIN_SCALE, max: MAX_SCALE,
    valueStr: val => `${Math.round(val * 100)}%`
  });

  pagination = Pagination({
    prev_title: 'Previous Figure',
    next_title: 'Next Figure'
  });
  pagination.init({
    container: elem.find('.figure-toolbar'),
    total: figures.length,
    current: index + 1
  }).on('paginate', (e, index) => setIndex(index - 1));

  transformable = elem.find('pinch-zoom')[0];
  elem.find('.figure-toolbar')
    .addClass('transformable');

  slider.set(transformable.scale);
  $(transformable).on('change', () => {
    slider.set(transformable.scale);
  });

  sidepanel.open(sidepanelOpt());
  sidepanel.on('closed', close);

  elem.find('.backdrop').click(function(e) {
    if (!$(this).is(e.target)) return;
    close();
  });

  $(window).on('keydown.figure-viewer', e => {
    if (e.metaKey || e.ctrlKey) return;
    switch (e.keyCode) {
      case 27: sidepanel.close(); break;
      case 37: case 38: prev(); break;
      case 39: case 40: next(); break;
    }
  });

  slider.on('slide', (e, val) => {
    if (!transformable) return;
    transformable.scaleTo(val, Object.assign(trOrigin(), {
      allowChangeEvent: false,
      relativeTo: 'container'
    }));
  });

  function trOrigin() {
    let brect = elem[0].getBoundingClientRect();
    return {
      originX: brect.left + (brect.width / 2),
      originY: brect.top + (brect.height / 2)
    };
  }

  function setIndex(index) {
    figure = Object.assign({ index }, figures[index]);
    update();
  }

  function next() {
    if (figure.index + 1 >= figures.length) return;
    setIndex(figure.index + 1);
  }

  function prev() {
    if (figure.index - 1 < 0) return;
    setIndex(figure.index - 1);
  }
}

function sidepanelOpt() {
  return {
    id: 'figure_details',
    title: figure.caption,
    content: figureDetails(figure),
    buttons: [
      {
        icon: fa.fileDownload,
        title: 'Download',
        handler: () => evtout.trigger('download', [figure.url])
      }
    ]
  };
}

function update() {
  img = $(`<img src="${figure.url}" class="grabbable"/>`);
  img.one('error', close);
  img.one('load', () => {
    resizeImgToFit();
    setBusy(false);
  });

  resetTransform();
  pagination.current = figure.index + 1;
  sidepanel.update(sidepanelOpt());

  elem.find('img').replaceWith(img);
  setBusy(true);
}

function setBusy(busy) {
  elem.toggleClass('busy', busy);
}

function close() {
  sidepanel.close();
  $(window).off('keydown.figure-viewer');
  resizeObserver && resizeObserver.disconnect();
  elem && elem.remove();
  resizeObserver = null;
  elem = null;
}

api.open  = open;
api.close = close;

module.exports = api;
